import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  GetServiceRequestDocument,
  GetServiceRequestQuery,
  GetServiceRequestQueryVariables,
  GetServiceRequestsDocument,
  GetServiceRequestsQuery,
  GetServiceRequestsQueryVariables,
  ServiceRequestFieldsFragment
} from '~/api/graphql';

export const getServiceRequests = async () =>
  queryData<
    GetServiceRequestsQuery,
    GetServiceRequestsQueryVariables,
    ServiceRequestFieldsFragment[]
  >(client, { query: GetServiceRequestsDocument }, (data) => data?.serviceRequests || []);

export const getServiceRequest = async (id: string) =>
  queryData<GetServiceRequestQuery, GetServiceRequestQueryVariables, ServiceRequestFieldsFragment>(
    client,
    { query: GetServiceRequestDocument, variables: { id: id } },
    (data) => data?.serviceRequest
  );

export const loadServiceRequests: LoaderFunction = () =>
  loadQuery(getServiceRequests(), { suppressAuthErrors: true });

export const loadServiceRequest: LoaderFunction = ({ params }) =>
  loadQuery(getServiceRequest(params.id || ''), { notFoundRedirect: '/app/servicing' });
